// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__coIni","compact":"Toolbar_compact__107pN","title":"Toolbar_title__2dk1g","search":"Toolbar_search__1LM5e","actions":"Toolbar_actions__1xIbe"};